import { ReactNode } from 'react';
import { DataTestId } from 'core/common/constants';
import { Icon, Stack } from 'core/common/ui/ui-kit';
import { IconButtonStyled } from './styled';

type ModalHeaderProps = {
  children?: ReactNode;
  onClose?: () => void;
  className?: string;
  closeButtonTestId?: DataTestId;
};

export const ModalHeader = ({
  children,
  onClose,
  className,
  closeButtonTestId = DataTestId.MODAL_CLOSE_BUTTON,
  ...props
}: ModalHeaderProps) => {
  return (
    <Stack className={className} {...props}>
      {onClose && (
        <IconButtonStyled onClick={onClose} data-testid={closeButtonTestId}>
          <Icon width={20} height={20} name="ic-close" />
        </IconButtonStyled>
      )}
      {children}
    </Stack>
  );
};
